exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\nNOTE:\nTHESE VARIABLES ARE HERE FOR THE SAKE OF COMPATIBILITY\nPLEASE USE THE ONES UNDER \"NEW NAMING\"\n*/\n\n/* NEW NAMING */\n\n/* families */\n\n/* size */\n\n/* General Indexes */\n\n/* Loading Layer */\n\n/* Component Indexes */\n\n/* Matching Pairs */\n\n/* Draw It */\n\n/* Global Transitions */\n\n.signup_base__wrapper--337Fe {\n\twidth: 100vw;\n\theight: 100vh;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.signup_base__header--3fjiQ {\n\tflex: 0 0 auto;\n}\n\n.signup_base__content--2VxUP {\n\tbackground-color: #fbfcfd;\n\tflex: 1 1 auto;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "signup_base__wrapper--337Fe",
	"header": "signup_base__header--3fjiQ",
	"content": "signup_base__content--2VxUP"
};